import { type SaveRemoteApiSpecMutationVariables } from "../../../api/graphql";

import { type RemoteApiFormValues } from "./remoteApiSpecSchema";

const mapParamtersFormValues = (parameters: RemoteApiFormValues["endpoints"][number]["parameters"]) => {
    return parameters?.map((parameter) => {
        const { location, name, required, constant, defaultValue } = parameter;

        return {
            location: location,
            name: name,
            optional: !required,
            constant: constant ?? false,
            defaultValue: defaultValue ?? "",
        };
    });
};
const mapEndpointFormValues = (endpoints: RemoteApiFormValues["endpoints"]) => {
    return endpoints.map((endpoint) => {
        const { path, methods, refId, parameters } = endpoint;

        return {
            path,
            methods,
            refId,
            parameters: mapParamtersFormValues(parameters) ?? [],
        };
    });
};

export const mapRemoteApiFormValues = (values: RemoteApiFormValues): SaveRemoteApiSpecMutationVariables => {
    const {
        documentationUrl,
        iconUrl,
        minLensStudioVersion,
        host,
        endpoints,
        customVisibilityUsersList,
        maxRequestSizeBytes,
        maxResponseSizeBytes,
        maxResponseTimeMillis,
        orgId,
        snapkitAppId,
        useBuiltinLocalProcessor,
        ...rest
    } = values;

    return {
        id: "",
        documentationUrl: documentationUrl ?? "",
        iconUrl: iconUrl ?? "",
        minLensStudioVersion: minLensStudioVersion ?? "",
        customVisibilityUsersList: customVisibilityUsersList ?? [],
        host: host ?? "",
        endpoints: mapEndpointFormValues(endpoints),
        // even though we have input type number, it comes as string from formik
        maxRequestSizeBytes: maxRequestSizeBytes ? Number.parseInt(`${maxRequestSizeBytes}`) : 0,
        maxResponseSizeBytes: maxResponseSizeBytes ? Number.parseInt(`${maxResponseSizeBytes}`) : 0,
        maxResponseTimeMillis: maxResponseTimeMillis ? Number.parseInt(`${maxResponseTimeMillis}`) : 0,
        orgId: orgId ?? "",
        snapkitAppId: snapkitAppId ?? "",
        useBuiltinLocalProcessor: useBuiltinLocalProcessor ?? true,
        localOnly: true,
        ...rest,
    };
};
